// Enhanced-search modal logic, extracted from snippets/enhanced-search.liquid
// so it is cacheable instead of ~5 KB inline on every page. Loaded with defer;
// the DOMContentLoaded listener below still fires after deferred execution.
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('enhanced-search-modal');
  if (!modal) return;
  
  const searchInput = document.getElementById('enhanced-search-input');
  const loader = document.getElementById('enhanced-search-loader');
  const form = document.querySelector('.enhanced-search-form');
  
  const resultsWrapper = document.getElementById('enhanced-search-results-wrapper');
  const noResultsWrapper = document.getElementById('enhanced-search-no-results-wrapper');
  const noResultsTerm = document.getElementById('no-results-term');

  let debounceTimer;

  function openSearch() {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    searchInput.focus();
  }

  function closeSearch() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  window.openEnhancedSearch = openSearch;

  document.querySelectorAll('[data-open-enhanced-search]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openSearch();
    });
    // Keyboard support for non-button triggers (e.g. the desktop .search-container
    // div, which has role="button" tabindex="0"): Enter fires click natively, but
    // Space does not — handle both explicitly so it behaves like a real button.
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        openSearch();
      }
    });
  });

  document.querySelectorAll('[data-close-enhanced-search]').forEach(el => {
    el.addEventListener('click', closeSearch);
  });
  
  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
    }
  });

  searchInput.addEventListener('input', () => {
    const query = searchInput.value.trim();
    clearTimeout(debounceTimer);
    
    if (query.length === 0) {
      resultsWrapper.style.display = 'none';
      noResultsWrapper.style.display = 'none';
      loader.style.display = 'none';
      return;
    }
    
    loader.style.display = 'flex';
    resultsWrapper.style.display = 'none';
    noResultsWrapper.style.display = 'none';
    
    debounceTimer = setTimeout(() => {
      fetchPredictiveSearch(query);
    }, 300);
  });
  
  async function fetchPredictiveSearch(query) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      renderSearchResults(data.resources.results.products, query);

    } catch (error) {
      console.error('Predictive search error:', error);
      loader.style.display = 'none';
      renderSearchResults([], query);
    }
  }

  // All API-sourced strings are escaped before being interpolated into
  // innerHTML; the search query additionally goes through encodeURIComponent
  // when used in a URL.
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderProduct(product) {
        try {
          const url = escapeHtml(product.url);
          const imageUrl = escapeHtml(product.image);
          const title = escapeHtml(product.title);

          let priceHTML = '';

          priceHTML = `<span class="current-price">${escapeHtml(product.price)}</span>`;
          if (product.compare_at_price && parseFloat(String(product.price).replace(/[^0-9.-]+/g,"")) < parseFloat(String(product.compare_at_price).replace(/[^0-9.-]+/g,""))) {
              priceHTML += `<span class="old-price">${escapeHtml(product.compare_at_price)}</span>`
          }

          const itemHTML = `
            <a href="${url}" class="product-item">
                <img src="${imageUrl}" alt="${title}" class="product-item__image" loading="lazy" width="200" height="200">
                <div class="product-item__info">
                    <h3 class="product-item__title">${title}</h3>
                    <div class="product-item__price">
                        ${priceHTML}
                    </div>
                </div>
            </a>
          `;
          return itemHTML;
        } catch (e) {
          console.error("Error rendering a product:", {product, error: e});
          return '';
        }
    }

  function renderSearchResults(products, query) {
    loader.style.display = 'none';
    resultsWrapper.innerHTML = '';

    if (products.length === 0) {
      noResultsWrapper.style.display = 'block';
      noResultsTerm.textContent = query;
      resultsWrapper.style.display = 'none';
      return;
    }
    
    noResultsWrapper.style.display = 'none';
    
    let productItemsHTML = products.map(p => renderProduct(p)).join('');

    let viewAllHTML = '';
    if (products.length > 0) {
        viewAllHTML = `
            <a href="/search?q=${encodeURIComponent(query)}&type=product" class="view-all-results">
                View all results
            </a>
        `;
    }
    
    resultsWrapper.innerHTML = `
      <div class="enhanced-search-results">
        ${productItemsHTML}
        ${viewAllHTML}
      </div>
    `;

    resultsWrapper.style.display = 'block';
  }
  
  

});
